import { formatGtmEventName } from './formatGtmEvent'
import LocalesEnum from '../enums/LocalesEnum'

export const SUSTAINABILITY_NAME = 'sustainability'
export const SUSTAINABILITY_REPORTS_NAME = 'sustainability_reports'

export const applyJobEvent = ({ pageCategory, title, location, id }) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Career_Section',
      action_type: 'click_apply',
      page_category: pageCategory,
      job_offer_title: title,
      job_location: location,
      job_ID: id,
    })
  }
}

export const filterJobEvent = ({
  language = LocalesEnum.en,
  newJobs,
  internships,
  remotePositions,
  countries,
  states,
  locations,
  categories,
}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Career_Section',
      action_type: 'select_filter',
      interface_language: language,
      filter_new_jobs: JSON.parse(newJobs),
      filter_internships: JSON.parse(internships),
      filter_remote_positions: JSON.parse(remotePositions),
      filter_countries: countries.length ? countries.join(', ') : null,
      filter_states: states.length ? states.join(', ') : null,
      filter_locations: locations.length ? locations.join(', ') : null,
      filter_categories: categories.length ? categories.join(', ') : null,
    })
  }
}

export const formEvent = ({ formName, formType, subject }) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Form_Submission',
      form_name: formName,
      form_type: formType,
      subject,
    })
  }
}

// muscle_shoals campaign
export const jobMuscleShoalsEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'job_muscle_shoals',
      action_type: 'job_filter_muscle_shoals_us',
      job_location: 'United states',
    })
  }
}

export const languageButtonEvent = ({
  pageCategory,
  ctaName,
  language = LocalesEnum.en,
}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Clic_CTA',
      page_category: pageCategory,
      cta_name: ctaName,
      interface_language: LocalesEnum[language],
    })
  }
}

// muscle_shoals campaign
export const locationHighlightButtonEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'muscle_shoals_section',
      action_type: 'clic_learn_more_muscle_shoals',
      job_location: 'United states',
    })
  }
}

// muscle_shoals campaign
export const locationJobButtonEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'find_job_btn_muscle_shoals',
      action_type: 'clic_find_job_muscle_shoals_us',
      job_location: 'United states',
    })
  }
}

export const mainSearchEvent = ({ keywords }) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Main_Search_Bar',
      search_terms: keywords,
    })
  }
}

export const mostViewedJobEvent = ({ pageCategory, title, location, id }) => {
  if (typeof window !== 'undefined') {
    dataLayer.push({
      event: 'Career_Section',
      page_category: pageCategory,
      interaction: 'impression',
      job_offer_title: title,
      job_location: location,
      job_ID: id,
    })
  }
}

export const searchEvent = ({ language = LocalesEnum.en, keywords }) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Career_Section',
      action_type: 'search_bar',
      search_terms: keywords,
      interface_language: language,
    })
  }
}

export const aboutUsLearnMoreEvent = ({ title }) => {
  const titleEvent = formatGtmEventName(title)
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: `learn_more_about_us_${titleEvent}`,
      action_type: `clic_learn_more_about_us_${titleEvent}`,
    })
  }
}

export const downloadDocumentEvent = ({ parentPageNameForGtm, name }) => {
  const pageNameEvent = formatGtmEventName(parentPageNameForGtm)
  const nameEvent = formatGtmEventName(name)

  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: `download_${pageNameEvent}_${nameEvent}`,
      action_type: `clic_download_${pageNameEvent}_${nameEvent}`,
    })
  }
}
